import { AppRoutes } from '@constants/app-routes'
import Back from '@public/images/scale-backend.svg'
import Devops from '@public/images/scale-devops.svg'
import Front from '@public/images/scale-frontend.svg'
import Mobile from '@public/images/scale-mobile.svg'

const techStackImageSize = {
  imageWidth: '110',
  imageHeight: '110',
}

export const config = {
  titleProps: {
    title: 'Extensive tech stack',
    subtitle: `Modsen experts have mastered an array of technologies to provide our partners with top-notch custom software development services that skyrocket businesses.`,
  },

  items: [
    {
      id: 1,
      title: 'Front-end',
      text: 'We create user interfaces using cutting-edge technologies.',
      imageComponent: <Front />,
      imageTitle: 'Front-end',
      imageClassName: 'scale-frontend',
      link: AppRoutes.frontend,
      ...techStackImageSize,
    },
    {
      id: 2,
      title: 'Back-end',
      text: 'We have mastered quality code writing to build clear product architecture.',
      imageComponent: <Back />,
      imageTitle: 'Back-end',
      imageClassName: 'scale-backend',
      link: AppRoutes.backend,
      ...techStackImageSize,
    },
    {
      id: 3,
      title: 'Mobile Development',
      text: 'We can easily optimize internal business processes and boost performance.',
      imageComponent: <Mobile />,
      imageTitle: 'Mobile Development',
      imageClassName: 'scale-mobile',
      link: AppRoutes.mobileDevelopment,
      ...techStackImageSize,
    },
    {
      id: 4,
      title: 'DevOps',
      text: 'We know how to incorporate mobile applications into your business seamlessly.',
      imageComponent: <Devops />,
      imageTitle: 'DevOps',
      imageClassName: 'scale-devops',
      link: AppRoutes.devOps,
      ...techStackImageSize,
    },
  ],
}
